import React from 'react';
import { useTickets } from '../../../contexts/TicketContext';

const PRIORITY_COLORS = {
    Low: '#1DA1F2',      // blue
    Medium: '#FBC02D',   // yellow
    High: '#E74C3C',     // red
};

const priorityList = [
    { key: 'Low', label: 'Low', color: PRIORITY_COLORS.Low },
    { key: 'Medium', label: 'Medium', color: PRIORITY_COLORS.Medium },
    { key: 'High', label: 'High', color: PRIORITY_COLORS.High },
];

const TicketPriorityChart = ({ tickets: propTickets }) => {
    const { tickets: contextTickets } = useTickets();
    const tickets = propTickets || contextTickets;
    const counts = priorityList.map(p => tickets.filter(t => t.priority === p.key).length);
    const barHeight = 28;

    return (
        <div className="flex flex-col p-4 items-center gap-2 justify-between card-container rounded-md h-full">
            <div className="flex flex-row items-center gap-4 justify-between w-full">
                <span className="text-lg text-font-secondary w-full">Priority</span>
                <div className="flex flex-row items-center justify-end gap-4 w-full">
                    {priorityList.map((priority, idx) => (
                        <div key={priority.key} className="flex flex-row items-center gap-1">
                            <span style={{ color: priority.color }} className="text-xl font-bold">{counts[idx]}</span>
                            <span className="text-base text-font-secondary">{priority.label}</span>
                        </div>
                    ))}
                </div>
            </div>
            {/* Horizontal stacked bar */}
            <div className="flex flex-row items-center w-full justify-center">
                <div className="flex flex-row overflow-hidden w-full" style={{ height: barHeight, borderRadius: 4, background: '#232427' }}>
                    {counts.map((count, idx) => (
                        <div
                            key={priorityList[idx].key}
                            style={{
                                flexGrow: count,
                                flexBasis: 0,
                                background: priorityList[idx].color,
                                height: '100%'
                            }}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TicketPriorityChart; 